import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import HeaderIcon from './components/HeaderIcon';
import { StylePropType } from '../../services/proptypes';
import ItemElement from '../ItemElement';
var Review = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Review, _React$PureComponent);
  var _super = _createSuper(Review);
  function Review() {
    _classCallCheck(this, Review);
    return _super.apply(this, arguments);
  }
  _createClass(Review, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        as = _this$props.as,
        author = _this$props.author,
        company = _this$props.company,
        text = _this$props.text,
        charLimit = _this$props.charLimit,
        image = _this$props.image,
        cardInlinePhoto = _this$props.cardInlinePhoto,
        imageCircular = _this$props.imageCircular,
        imageSize = _this$props.imageSize,
        itemButtonFloat = _this$props.itemButtonFloat,
        itemCenterContent = _this$props.itemCenterContent,
        link = _this$props.link,
        linkAs = _this$props.linkAs,
        verticalItemAlign = _this$props.verticalItemAlign;
      return /*#__PURE__*/React.createElement(ItemElement, {
        className: className,
        style: style,
        as: as,
        header: author,
        headerIcon: link ? /*#__PURE__*/React.createElement(HeaderIcon, {
          link: link,
          showLink: linkAs !== 'header',
          isVerticalItem: as === 'verticalItem'
        }) : null,
        subheader: company,
        content: text,
        charLimit: charLimit,
        image: image,
        cardInlinePhoto: cardInlinePhoto,
        imageCircular: imageCircular,
        imageSize: imageSize,
        itemButtonFloat: itemButtonFloat,
        itemCenterContent: itemCenterContent,
        link: link,
        linkAs: linkAs,
        verticalItemAlign: verticalItemAlign,
        event: {
          category: 'Reviews',
          action: 'click',
          label: 'See more'
        }
      });
    }
  }]);
  return Review;
}(React.PureComponent);
export { Review as default };
Review.defaultProps = {
  className: '',
  style: {},
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 280,
  company: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  author: '',
  verticalItemAlign: 'center'
};